module.exports = __webpack_public_path__ + "img/banner.f2f63423.png";